import * as z from "zod";

export const SubscriptionEditingActionSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("quantity"),
    quantity: z.number().int().min(1).max(999),
  }),
  z.object({
    type: z.literal("frequency"),
    frequency: z.number().int().positive(),
    unit: z.enum(["day", "week", "month"]),
  }),
  z.object({ type: z.literal("nextDate"), date: z.string().date() }),
  z.object({ type: z.literal("skip") }),
  z.object({ type: z.literal("cancel") }),
  z.object({
    type: z.literal("address"),
    address: z.object({
      address1: z.string().trim().min(1).max(255),
      address2: z.string().trim().max(255).optional(),
      city: z.string().trim().min(1).max(255),
      province: z.string().trim().max(255),
      zip: z.string().trim().max(32),
      country: z.string().regex(/^[A-Z]{2}$/),
    }),
  }),
]);
export type SubscriptionEditingAction = z.infer<
  typeof SubscriptionEditingActionSchema
>;
export type SubscriptionEditingActionType = SubscriptionEditingAction["type"];

export const SubscriptionSelfServiceSettingsSchema = z.object({
  enabled: z.boolean(),
  quantity: z.boolean(),
  frequency: z.boolean(),
  nextDate: z.boolean(),
  skip: z.boolean(),
  cancel: z.boolean(),
  address: z.boolean(),
});
export type SubscriptionSelfServiceSettings = z.infer<
  typeof SubscriptionSelfServiceSettingsSchema
>;

export const CustomerSubscriptionSchema = z.object({
  id: z.number().int().positive(),
  title: z.string(),
  productId: z.string().optional(),
  variantId: z.string().optional(),
  status: z.string(),
  quantity: z.number(),
  price: z.string().optional(),
  currency: z.string().optional(),
  nextDate: z.string().optional(),
  frequency: z.number().optional(),
  unit: z.enum(["day", "week", "month"]).optional(),
  frequencyOptions: z.array(
    z.object({
      frequency: z.number().int().positive(),
      unit: z.enum(["day", "week", "month"]),
    }),
  ),
  address: z
    .object({
      address1: z.string(),
      address2: z.string(),
      city: z.string(),
      province: z.string(),
      zip: z.string(),
      country: z.string(),
    })
    .optional(),
  actions: z.array(
    z.enum(["quantity", "frequency", "nextDate", "skip", "cancel", "address"]),
  ),
  addressSubscriptionCount: z.number().int().nonnegative(),
});
export type CustomerSubscription = z.infer<typeof CustomerSubscriptionSchema>;

export function getSubscriptionSelfServiceSettings(
  settings:
    | { [Key in keyof SubscriptionSelfServiceSettings]?: boolean | null }
    | null
    | undefined,
): SubscriptionSelfServiceSettings {
  return SubscriptionSelfServiceSettingsSchema.parse({
    enabled: settings?.enabled === true,
    quantity: settings?.quantity === true,
    frequency: settings?.frequency === true,
    nextDate: settings?.nextDate === true,
    skip: settings?.skip === true,
    cancel: settings?.cancel === true,
    address: settings?.address === true,
  });
}
